import React from 'react';
import { cn } from '../../lib/utils';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  className
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-681">
      <div className={cn('relative w-full max-w-md bg-white rounded-3xl shadow-2xl p-6 animate-in zoom-in-95 duration-200', className)} data-id="element-682">
        <div className="flex items-center justify-between mb-4" data-id="element-683">
          {title && <h2 className="text-xl font-bold text-slate-900" data-id="element-684">{title}</h2>}
          <button onClick={onClose} className="p-2 -mr-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-685">
            <X size={20} data-id="element-686" />
          </button>
        </div>
        {children}
      </div>
    </div>;
}